const WEBAPP_URL = import.meta.env.VITE_WEBAPP_URL

export const webappSiteUrl = (siteId: string): string => `${WEBAPP_URL}/sites/${siteId}/overview`

export const webappStationUrl = (siteId: string, stationId: string): string =>
  `${WEBAPP_URL}/sites/${siteId}/config/stations/${stationId}`
